const wrapElement = (el, wrapperClass = "wrp") => {
    const wrapper = document.createElement('div');
    wrapper.classList.add(wrapperClass);
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el)
    return wrapper
}

const isTouch = () => {
    if (window.matchMedia("(pointer: coarse)").matches) {
        return true;
    }
    return false;
}



export { wrapElement, isTouch }